import { render, staticRenderFns } from "./Punch.vue?vue&type=template&id=940d37aa&"
import script from "./Punch.vue?vue&type=script&lang=js&"
export * from "./Punch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports